import React from "react";

const Section1Mission = () => (
  <>
    <h2>2. Our Mission</h2>
    <p>At <i>Comparedly</i>, our mission is clear and unwavering: </p>
    <p>
    <strong>To empower brands, creators, and teams with meaningful insights that drive confident decisions and measurable impact across every social channel.
    </strong></p>
    <p>
    In today’s hyperconnected world, content is abundant but clarity is rare. Likes, views, shares, and comments often create noise rather than direction. We believe social media analytics should be more than just vanity metrics — they should illuminate what matters.
    </p>
    <h3>2.1 We Exist to Simplify the Complex</h3>
    <p>Our goal is to transform fragmented social media data into a unified story — one that’s easy to understand, contextualized for impact, and immediately actionable. We are here to eliminate data silos and provide a single lens through which you can evaluate your performance across platforms.
    </p>
    <h3>2.2 Putting Power in Your Hands</h3>
    <p>Whether you're a digital strategist, a social media manager, a creator, or a founder juggling marketing with a dozen other priorities — Comparedly is built with you in mind. Our mission is to:
    <ul>
        <li><strong>Democratize data</strong> by making it accessible, even to non-analysts.</li>
        <li><strong>Enable agility</strong> by surfacing insights faster than traditional reporting cycles.</li>
        <li><strong>Foster confidence</strong> in decision-making by grounding choices in evidence, not assumptions.</li>
    </ul>
    </p>
    <h3>2.3 Driven by Purpose, Not Just Product</h3>
    <p>Our mission extends beyond features and dashboards. It’s about <strong>building trust</strong> in every insight we deliver, <strong>reducing friction</strong> in every workflow we design, and <strong>delivering value</strong> that reflects our users' real goals — from growing a community to optimizing campaigns, to proving ROI.
    </p>
  </>
);

export default Section1Mission;
